import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import { ChatContext } from 'context/Context';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';
import ChatContactsSearch from './ChatContactSearch';
import ChatThread from './ChatThread';
import { useSelector } from 'react-redux';

const ChatSidebar = ({ hideSidebar, setHideSidebar }) => {
  const { isSearchConversation } = useContext(ChatContext);
  const conversations = useSelector(state => state.chat.conversations);

  return (
    <div
      className={classNames('chat-sidebar bg-white', {
        'start-0': hideSidebar
      })}
    >
      <div
        className="contacts-list"
        style={{
          overflowX: 'hidden'
        }}
      >
        <SimpleBarReact
          style={{
            height: '100%',
            minWidth: '65px',
            overflowX: 'hidden'
          }}
        >
          <Flex
            className="chat-content-header align-items-center justify-content-between p-3 unread-message"
            style={{ height: '68px' }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: '32px',
                height: '32px'
              }}
            >
              <FontAwesomeIcon
                icon={['fa-regular', 'comment']}
                className="fs-2 text-700"
              />
            </div>

            <h5
              className={classNames(
                'flex-1 ms-2 d-lg-block opacity-lg-100 ms-lg-2 fs-0 m-0',
                {
                  'opacity-md-0': !isSearchConversation,
                  'w-md-0': !isSearchConversation,
                  'ms-md-0': !isSearchConversation
                }
              )}
              style={{
                transition: 'all 0.3s ease-in'
              }}
            >
              Conversaciones
            </h5>

            <div
              className="text-700 d-md-none contacts-list-show cursor-pointer d-flex align-items-center fs-1"
              onClick={() => setHideSidebar(false)}
            >
              <FontAwesomeIcon icon="times" />
            </div>
          </Flex>

          <Nav className="border-0">
            {conversations.map((thread, index) => (
              <ChatThread thread={thread} index={index} key={thread.id} />
            ))}
          </Nav>
        </SimpleBarReact>
      </div>

      <ChatContactsSearch />
    </div>
  );
};

ChatSidebar.propTypes = {
  hideSidebar: PropTypes.bool,
  setHideSidebar: PropTypes.func
};

export default ChatSidebar;
